import type { JSX } from 'react';

import { Contacts } from '~components/Order/Contacts';

import { useProjectFormV2Context } from '../ProjectFormV2Context';

// Mirrors the legacy form — a one-line render-only wrapper around
// the existing `<Contacts/>` component. `<Contacts/>` already calls
// `useFormContext()` internally so the Provider's FormProvider is the only
// wiring required. `defaultProject` flows in through context (set by the
// Provider from the dialog's `defaultProject` prop). Do NOT fork
// `<Contacts/>` — this panel's contract is "wrapper only".
export function ContactsPanel(): JSX.Element {
  const { defaultProject, isSalespersonRequired } = useProjectFormV2Context();
  return (
    <Contacts
      defaultData={defaultProject}
      isSalespersonRequired={isSalespersonRequired}
    />
  );
}
